import type { OrganizationsHost } from './host';
import { createOrganizationsRoutes } from './route';

/**
 * The module for the app to mount: its services-hub route (plain data; the console stays a lazy
 * chunk behind `route.ts`) and the loader of the two top-level pages the router mounts outside the
 * hub (`/teams/join`, `/teams/invitations/:memberId`; they read the shared data layer only, so they
 * need no host). The host is a lazy factory, not a value: the app file that builds it imports the
 * compute hooks the entry chunk does not need, so it is fetched when the route loads and registered
 * before any code of the console runs.
 */
export function createOrganizationsModule(loadHost: () => Promise<OrganizationsHost>) {
  return {
    servicesRoutes: createOrganizationsRoutes(loadHost),
    pages: { load: () => import('./public') },
  };
}

export type { OrganizationsHost } from './host';
